// extracted by mini-css-extract-plugin
export default {"root":"root___XbLFj","extraFiltersBtn":"extraFiltersBtn___u7a8l","label":"label___fk0qh","searchFooter":"searchFooter___pkHg9","searchBtn":"searchBtn___FEFaP"};